/* eslint-disable react/no-danger */
import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Image from '@nubank/nuds-web/components/Image/Image';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTitle = styled(Typography)`
  font-size: 24px;
`;

const StyledDescription = styled(Typography)`
  span { 
    font-weight: bold;
  }
`;

const StyledImage = styled(Image)` 
  object-fit: cover;
  height: 100%;
  border-radius: 0 12px 12px;
`;

function DesktopFeatureCard({
  imageDesktop,
  alt,
  title,
  description,
  id,
}) {
  return (
    <Box
      id={`card-${id}`}
      display="flex"
      flexDirection={{ xs: 'column', lg: 'row' }}
      height="100%"
    >
      {/* CONTENT BOX */}

      <Box
        backgroundColor="#F8F8FA"
        padding={{ xs: '8x', lg: '6x' }}
        borderRadius={{ md: '12px 12px 0px 0px', lg: '12px 0px 0px 12px' }}
        width={{ xs: '100%', lg: '50%' }}
        height={{ xs: '315px', lg: '100%' }}
        display="flex"
        justifyContent="center"
      >

        <Box
          alignSelf="center"
          paddingHorizontal={{ xs: '0', lg: '16x' }}
        >
          <StyledTitle
            variant="heading4"
            marginBottom="8x"
            maxWidth="235px"
            whiteSpace="normal"
          >
            {title}
          </StyledTitle>

          <StyledDescription
            variant="subtitle1"
            marginBottom="8x"
            maxWidth="400px"
          >
            {description}
          </StyledDescription>

        </Box>

      </Box>

      {/* IMAGE BOX */}

      <Box
        background="linear-gradient(151deg, #9F2DEB 1.22%, #6200A3 64.1%), #7B4DD6"
        width={{ xs: '100%', lg: '50%' }}
        display="flex"
        justifyContent="center"
        borderRadius={{ md: '0px 0px 12px 12px', lg: '0px 12px 12px 0px' }}
        paddingHorizontal={{ xs: '8x', lg: '0' }}
        paddingTop={{ xs: '6x', lg: '0' }}
      >
        <StyledImage
          src={imageDesktop}
          alt={alt}
          loading="lazy"
        />
      </Box>

    </Box>

  );
}

DesktopFeatureCard.propTypes = {
  alt: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  imageDesktop: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default DesktopFeatureCard;
